// eslint-disable-next-line object-curly-newline
import { format, add, isBefore, set, getHours } from 'date-fns';
import formats from './formats';

// Options for date and time picker
const options = {
    date: [[]],
    time: [],
};

for (let i = 0; i < 7; i += 1) {
    const value = add(new Date(), {
        days: i,
    });

    const aliases = ['Today', 'Tomorrow'];

    // eslint-disable-next-line operator-linebreak
    const upper = format(value, formats.dateLong.upper);
    const bottom = aliases[i]
        ? aliases[i]
        : format(value, formats.dateLong.bottom);

    options.date[0].push({
        label: format(value, formats.date),
        long: `<span class="upper">${upper}</span>
                <div><span class="bottom">
                    ${bottom}
                </span></div>`,
        value,
        comparable: format(value, formats.date),
    });
}

const closestWholeHour = set(
    add(new Date(), {
        hours: 1,
    }),
    {
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
    },
);
const beginningToday = set(new Date(), {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
});
const minTime = beginningToday;
const maxTime = add(minTime, {
    hours: 24,
});
let nowTime = minTime;
let lastHour = null;
let currentHour = null;

while (isBefore(nowTime, maxTime)) {
    currentHour = getHours(nowTime);

    if (lastHour !== currentHour) {
        options.time.push([]);
    }

    const currentIndex = options.time.length - 1;

    options.time[currentIndex].push({
        label: format(nowTime, formats.time),
        value: nowTime,
        comparable: format(nowTime, formats.time),
    });

    nowTime = add(nowTime, {
        minutes: 15,
    });

    lastHour = currentHour;
}

export { options, closestWholeHour };
